export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/apple-icon-82afbfaa2a64cebfd0077f73abe15659.png";